import React from "react";
import styled from "styled-components";
import Facebook from "../images/facebook.png";
import Instagram from "../images/instagram.png";
import Twitter from "../images/twitter.png";
import Linkedin from "../images/linkedin.png";
import Github from "../images/github.png";
import Fiverr from "../images/fiverr.png";

const C = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 40px;
  border-top: 1px solid #dee2e6;
`;
const CLeft = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
`;
const Link = styled.a`
  cursor: pointer;
  margin: 0px 15px;
`;
const Img = styled.img`
  width: 23px;
  height: 23px;
  object-fit: cover;
`;
const CCenter = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 700;
`;
const CRight = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const Footer = () => {
  return (
    <C>
      <CLeft>
        <Link href="https://www.facebook.com/gauravmeena41" target="_blank">
          <Img src={Facebook} />
        </Link>
        <Link href="https://www.instagram.com/dev__gaurav01/" target="_blank">
          <Img src={Instagram} />
        </Link>
        <Link href="https://twitter.com/Gurumeena6" target="_blank">
          <Img src={Twitter} />
        </Link>
      </CLeft>
      <CCenter>&copy; 2021 Gaurav Meena</CCenter>
      <CRight>
        <Link
          href="https://www.fiverr.com/gauravmeena41?up_rollout=true"
          target="_blank"
        >
          <Img src={Fiverr} style={{ width: "60px", borderRadius: "10px" }} />
        </Link>
        <Link
          href="https://www.linkedin.com/in/guruprasad-m-922041132/"
          target="_blank"
        >
          <Img src={Linkedin} />
        </Link>
        <Link href="https://github.com/gauravmeena41" target="_blank">
          <Img src={Github} />
        </Link>
      </CRight>
    </C>
  );
};

export default Footer;
